export const hasTouchScreen = () => {
  const maxTouchPoints =
    navigator.maxTouchPoints || navigator.msMaxTouchPoints || 0

  if (maxTouchPoints > 0) {
    const isDesktopFirefox =
      navigator.userAgent.includes('Firefox') &&
      !/Mobi|Android|Tablet|Touch/i.test(navigator.userAgent)

    if (!isDesktopFirefox) {
      return true
    }
  }

  const isOldiOS = /\b(iPhone|iPad|iPod)\b/.test(navigator.userAgent)
  if (isOldiOS) {
    return true
  }

  if (
    window.matchMedia &&
    window.matchMedia('(pointer: coarse)').matches &&
    /Mobi|Android|Tablet|Touch/i.test(navigator.userAgent)
  ) {
    return true
  }

  return false
}
